<!-- components/SwapFreeGroup.vue -->
<!-- #BR#103 Mbeng 14/07/2025 SwapFreePopup for the list of trading account groups -->
<template>
    <div
      v-if="visible"
      class="fixed inset-0 z-50 flex items-center justify-center bg-opacity-30"
    >
    <div class="relative bg-white p-6 rounded-lg shadow-md max-w-sm w-full text-center">
        <button
            @click="$emit('close')"
            class="absolute top-3 right-3 text-gray-400 hover:text-black"
            >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none"
                viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M6 18L18 6M6 6l12 12" />
            </svg>
            </button>
                
          <div class="text-center mb-4">
            <img src="@/assets/icm-logo.svg" alt="ICM.com" class="mx-auto h-8" />
        </div>
        <div class="flex items-center justify-center mb-3">
        
          <svg
            class="h-6 w-6 text-yellow-400 mr-2"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              clip-rule="evenodd"
              fill-rule="evenodd"
              d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
            />
          </svg>
          <h3 class="text-lg font-semibold text-yellow-700">
            {{$t("important-update-for-swap-free")}}
          </h3>
        </div>
        <p class="text-sm text-gray-700 mb-4">
            {{$t("effective-august-1st-position-held-on-swap-free")}} 
        </p>
        <p class="text-sm text-gray-700 mt-2 mb-4">
            {{$t("we-remain-committed-to-transparency-and-fairness")}} 
        </p>
        <br>
        <!-- <a :href="computedPdfUrl"
           target="_blank"
           rel="noopener noreferrer"
           class="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
            {{$t("terms-and-conditions")}}
        </a> -->
        <button v-if="whitelabel === 'ICMMU'"
           class="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
           v-html="$t('terms-and-conditions-popup-mu')">
           
        </button>
        <button v-else
           class="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
           v-html="$t('terms-and-conditions-popup-vc')">
           
        </button>

        <button
          class="block text-sm text-gray-500 mt-3 mx-auto hover:underline"
          @click="$emit('close')"
        >
          {{ $t("i-understand") }}
        </button>
      </div>
    </div>
  </template>
  
  <script>
import { mapGetters } from "vuex";

export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    countdown: {
      type: Number,
      default: 0,
    },
    deadline: {
      type: Date,
      required: true
    },
  },
  data() {
    return {
      timeLeft: '',
      countdownTimer: null,
      
    };
  },
  name: "SwapFreeGroup",
  computed: {
    ...mapGetters(["get_profile", "get_user_data"]),
    userLanguage() {
    return this.get_profile?.profile?.language;
  },
  
    computedPdfUrl() {
      const lang = this.get_profile?.profile?.language || 'en';

      const mapICMMU = {
        en: 'https://www.icm.com/static/media/documents/mu/icmmu-terms-conditions-en.pdf',
        ar: 'https://www.icm.com/static/media/documents/mu/icmmu-terms-conditions-ar.pdf',
        es: 'https://www.icm.com/static/media/documents/mu/icmmu-terms-conditions-es.pdf',
        pt: 'https://www.icm.com/static/media/documents/mu/icmmu-terms-conditions-en.pdf',
        th: 'https://www.icm.com/static/media/documents/mu/icmmu-terms-conditions-th.pdf',
        ms: 'https://www.icm.com/static/media/documents/mu/icmmu-terms-conditions-my.pdf',
        vi: 'https://www.icm.com/static/media/documents/mu/icmmu-terms-conditions-vi.pdf',
        id: 'https://www.icm.com/static/media/documents/mu/icmmu-terms-conditions-indo.pdf',
      };

      const mapICMVC = {
        en: 'https://www.icm.com/static/media/documents/vc/icmvc-terms-conditions-en.pdf',
        ar: 'https://www.icm.com/static/media/documents/vc/icmvc-terms-conditions-ar.pdf',
        es: 'https://www.icm.com/static/media/documents/vc/icmvc-terms-conditions-en.pdf',
        pt: 'https://www.icm.com/static/media/documents/vc/icmvc-terms-conditions-en.pdf',
        th: 'https://www.icm.com/static/media/documents/vc/icmvc-terms-conditions-en.pdf',
        ms: 'https://www.icm.com/static/media/documents/vc/icmvc-terms-conditions-en.pdf',
        vi: 'https://www.icm.com/static/media/documents/vc/icmvc-terms-conditions-en.pdf',
        id: 'https://www.icm.com/static/media/documents/vc/icmvc-terms-conditions-en.pdf',
      };

      return process.env.VUE_APP_WHITELABEL === 'ICMMU'
        ? mapICMMU[lang] || mapICMMU.en
        : mapICMVC[lang] || mapICMVC.en;
    },

    userGroup() {
      return this.get_user_data?.trading_accounts?.[0]?.group_name || '';
    },
    formattedCountdown() {
      const minutes = Math.floor(this.countdown / 60);
      const seconds = this.countdown % 60;
      return `${minutes}:${String(seconds).padStart(2, '0')}`;
    },

    whitelabel() {
    return this.get_profile?.whitelabel; 
  },
  },
  mounted() {
    this.startCountdown();
  },
  beforeDestroy() {
    clearInterval(this.countdownTimer);
  },
  methods: {
    startCountdown() {
      this.updateTimeLeft();
      this.countdownTimer = setInterval(this.updateTimeLeft, 1000);
    },
    updateTimeLeft() {
      const now = new Date();
      const diff = this.deadline - now;

      if (diff <= 0) {
        this.timeLeft = '0 minutes';
        clearInterval(this.countdownTimer);
        this.$emit('lockout');
        return;
      }

      const minutes = Math.floor(diff / 1000 / 60) % 60;
      const hours = Math.floor(diff / 1000 / 60 / 60) % 24;
      const days = Math.floor(diff / 1000 / 60 / 60 / 24);

      this.timeLeft = `${days}d ${hours}h ${minutes}m`;
    },
    
  }
};
</script>
